import { useTranslation } from 'react-i18next';

export default function TrustBar() {
  const { t } = useTranslation();

  const items = [
    { icon: 'ri-shield-check-line', label: t('trust.independent') },
    { icon: 'ri-refresh-line', label: t('trust.updated') },
    { icon: 'ri-global-line', label: t('trust.multilingual') },
    { icon: 'ri-lock-line', label: t('trust.safety') },
  ];

  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10 py-6 md:py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {items.map((item) => (
            <div key={item.label} className="flex items-center gap-3">
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 shrink-0">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <span className="text-sm md:text-base font-medium text-foreground-700">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}